import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IIdItem } from '../types/resourceParts';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ISetDatasourceRemoteAgentReservationParams extends IIdItem {
  remoteAgentReservationId: string;
}

export interface ISetDatasourceRemoteAgentReservationResult extends IResult {
  updatedRemoteAgentName: string;
}

export class SetDatasourceRemoteAgentReservationRequest
  extends Request<ISetDatasourceRemoteAgentReservationParams, ISetDatasourceRemoteAgentReservationResult> {

  constructor(params: ISetDatasourceRemoteAgentReservationParams) {
    super('setDatasourceRemoteAgentReservation', params);
  }
}
